const PayWithLOCQPayStatus = {
  Success: "success",
  Pending: "pending",
  Failed: "failed",
  Voided: "voided",
};

export default PayWithLOCQPayStatus;
